export const getCourseMenu = ({
  isCourseListActionsMenu = false,
  isDetailedCourseActionsMenu = false,
  createClassMeetings,
  deleteCourseMeetings,
  switchToPersonalZoom,
  switchToWebEx,
  addCodecs,
  removeCodecs,
  createCalendarEntries,
  createAdhocMeeting,
  enableGuest = null,
}) => {
  const commonMenu = [
    {
      handler: createClassMeetings,
      title: 'Create Class Meetings',
    },
    {
      handler: deleteCourseMeetings,
      title: 'Delete Class Meetings',
    },
    {
      handler: switchToPersonalZoom,
      title: 'Switch to Personal Zoom Meeting link',
    },
    {
      handler: switchToWebEx,
      title: 'Switch to WebEx',
    },
    {
      handler: addCodecs,
      title: 'Add Codecs',
    },
  ];

  const courseMenu = [
    {
      handler: removeCodecs,
      title: 'Remove Codecs',
    },
    {
      handler: createCalendarEntries,
      title: 'Create Calendar Entries',
    },
    {
      handler: createAdhocMeeting,
      title: 'Create Adhoc Meeting(s)',
    },
  ];

  if (isCourseListActionsMenu) {
    return commonMenu.concat(courseMenu);
  } else if (isDetailedCourseActionsMenu) {
    const menu = commonMenu.concat(courseMenu);
    menu.push({
      handler: enableGuest,
      title: 'Enable Guest for Future Meetings',
    });
    return menu;
  } else {
    return commonMenu;
  }
};
